import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { fetchAnnouncements } from "@/lib/api";
import { Megaphone, ArrowRight } from "lucide-react";

export default function AnnouncementsStrip() {
  const { pick } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { fetchAnnouncements().then((d) => setItems(d.slice(0, 3))).catch(() => {}); }, []);
  if (items.length === 0) return null;

  const Card = ({ a }) => {
    const inner = (
      <div className="group flex h-full items-start gap-3 border border-line bg-[var(--surface)] p-4 transition-colors hover:border-saffron/50">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[rgba(199,80,0,0.08)] text-saffron"><Megaphone className="h-4 w-4" /></span>
        <span className="min-w-0 flex-1">
          <span className="block font-serif-latin text-base text-ink transition-colors group-hover:text-saffron">{a.title}</span>
          {a.body && <span className="mt-0.5 line-clamp-2 block text-sm text-ink-2">{a.body}</span>}
        </span>
        {a.link && <ArrowRight className="h-4 w-4 shrink-0 text-ink-3 opacity-0 transition-opacity group-hover:opacity-70" />}
      </div>
    );
    return a.link ? <a href={a.link} data-testid={`ann-${a.id}`} className="block">{inner}</a> : <div data-testid={`ann-${a.id}`}>{inner}</div>;
  };

  return (
    <section className="border-t border-line bg-[var(--parchment)]" data-testid="home-announcements">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <p className="overline-label text-gold">{pick("घोषणाएँ", "Announcements")}</p>
        <div className="mt-4 grid gap-4 md:grid-cols-3">
          {items.map((a) => <Card key={a.id} a={a} />)}
        </div>
      </div>
    </section>
  );
}
